import React from "react";
import { motion } from "framer-motion";
import BeLaunchifiedComponent from "../components/BeLaunchifiedPage/BeLaunchified/BeLaunchified";

const BeLaunchified = () => {
  return (
    <motion.div
      initial={{ y: "-100vh", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <div>
        <BeLaunchifiedComponent />
      </div>
    </motion.div>
  );
};

export default BeLaunchified;
